import React from "react";
import "../less/hint.less";

export default function template() {
    const { isShown } = this.state,
        hintContent = this.props.children;

    return (
        <div className="hint-icon"
            onMouseEnter={this.showHintContent}
            onMouseLeave={this.hideHintContent}
        >
            <div className={`hint-body ${isShown ? "active" : ""}`}>
                {hintContent}
                <div className="triangle" />
            </div>
        </div>
    )
}